import { ModalContentType } from "components/adhoc/gistreehierarchy";
import { HierarchyItemType, SetStateType } from "types/generic";

type MakeGisTreeHierarchyFunctionsParams = {
    setModalContentType: SetStateType<ModalContentType>;
    gisHierarchySelected: HierarchyItemType[];
};

export const getFirstHierarchyGroupOnList = (list: HierarchyItemType[]) => {
    if (list) {
        return list.find((hierarchy) => !hierarchy.itemType);
    } else {
        return undefined;
    }
};

export const makeGisTreeHierarchyFunctions = ({
    setModalContentType,
    gisHierarchySelected,
}: MakeGisTreeHierarchyFunctionsParams) => {
    const closeModalFn = () => {
        setModalContentType("");
    };

    const openModalFn = (modalType: ModalContentType) => {
        setModalContentType(modalType);
    };

    const defineAddButtonStatus = (): "enabled" | "disabled" => {
        if (gisHierarchySelected.length) {
            if (gisHierarchySelected[0].itemType) {
                const hasGroupOnList =
                    getFirstHierarchyGroupOnList(gisHierarchySelected);
                if (!hasGroupOnList) return "disabled";
            }
        }

        return "enabled";
    };

    return {
        closeModalFn,
        openModalFn,
        defineAddButtonStatus,
    };
};
